/* index.js */

"use strict";

module.exports = {
    JsonDiffControlComponent: require("./json_diff_control/JsonDiffControlComponent"),
};
